import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DeleteIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18 7V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7H18ZM14.1213 10.4645L12 12.5858L9.87868 10.4645L8.46447 11.8787L10.5851 13.9993L8.46447 16.1213L9.87868 17.5355L12 15.4142L14.1213 17.5355L15.5355 16.1213L13.4142 14L15.5355 11.8787L14.1213 10.4645ZM15 3L15.5 4H19V6H5V4H8.5L9 3H15Z'
        />
    ),
})

DeleteIcon.displayName = 'DeleteIcon'
